import { createI18n } from 'vue-i18n'
import {messages, defaultLanguage} from '@/locales'

export default createI18n({
  globalInjection: true,
  locale: defaultLanguage,
  fallbackLocale: 'ua',
  messages: {
    en: messages.en,
    ua: messages.ua
  }
  // messages: {
  //   en: require('./locales/en.json'),
  //   ru: require('./locales/ru.json'),
  //   ua: require('./locales/ua.json')
  // }
})
